import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import MainCard from 'ui-component/cards/MainCard';
import { DataGrid } from '@mui/x-data-grid';

import Util from 'utils/Util';
import { HearingAidPriceModel } from 'models/HearingAidPrice';

const HearingAidPrices = ({ hearingAidPrices = [], onClick, onAdd }) => {
    const columns = [
        {
            field: 'title', headerName: '이름', width: 130,
            renderCell: (params) => (
                <div style={{ cursor: 'pointer' }} onClick={() => { onRowClick(params) }}>{params.value}</div>
            ),
            sortable: true,
        },
        {
            field: 'type', headerName: '종류', width: 130,
            renderCell: (params) => (
                <div style={{ cursor: 'pointer' }} onClick={() => { onRowClick(params) }}>{params.value}</div>
            ),
            sortable: true,
        },
        {
            field: 'price', headerName: '가격', width: 130,
            renderCell: (params) => (
                <div style={{ cursor: 'pointer' }} onClick={() => { onRowClick(params) }}>{params.value}</div>
            ),
            sortable: true,
        },
        {
            field: 'first', headerName: '메인', width: 130,
            renderCell: (params) => (
                <div style={{ cursor: 'pointer' }} onClick={() => { onRowClick(params) }}>{(params.value == 'true') ? 'O' : 'X'}</div>
            ),
            sortable: true,
        },
    ];

    const navigate = useNavigate();

    const onRowClick = (params) => { // 상세보기
        onClick(hearingAidPrices.find(hearingAidPrice => hearingAidPrice.id === params.row.id));
    };

    const addHearingAidPrice = () => { // 추가
        onAdd();
    };

    return (
        <MainCard title="보청기 가격">
            <div style={{ textAlign: 'right' }}>
                <Button variant="contained" color="secondary" sx={{ boxShadow: 'none', mb: 2 }}
                    onClick={addHearingAidPrice}>추가</Button>
            </div>
            <DataGrid
                rows={hearingAidPrices}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                    },
                }}
                pageSizeOptions={[5, 10, 20, 30]}
                disableRowSelectionOnClick
            />
        </MainCard >
    );
};

export default HearingAidPrices;